window.addEventListener('DOMContentLoaded', function() {
  // パラメーター取得
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search); 
  const keywordParam = params.get('keyword'); 
  const keywords = keywordParam ? keywordParam.replace(/\+/g, ' ').split(' ') : [];//絞り込み値 キーワード
  const prefecture = params.get('prefecture'); //絞り込み値 都道府県
  const product = params.get('product'); //絞り込み値 商品

  const allStores = document.querySelectorAll('[data-prefecture]'); // 全店舗
  let resultStoreCount = 0;

  // 検索条件を表示
  const searchTitleAreaWrapper = document.getElementById('searchTitleArea');
  const searchTitleArea = document.getElementById('searchTitle');
  
  let searchTitle = [prefecture, keywordParam, product].filter(Boolean).join(' ');
  
  if (searchTitle) {
    searchTitleArea.innerText = `「${searchTitle}」`;
  } else {
    searchTitleAreaWrapper.style.display = "none";
  }
  
  //全店舗をループし各条件で絞り込みを行う
  allStores.forEach(function(store) {
    // 都道府県をもとに絞り込み
    if(prefecture) {
      const dataPrefecture = store.getAttribute('data-prefecture');
      if (!prefecture.includes(dataPrefecture)) {
        store.style.display = 'none';
      }
    }
    // キーワードをもとに絞り込み
    // 検索したキーワードが「店舗名、住所、電話番号」に含まれていなければ店舗を非表示
    if(keywords) {
      const dataStore = store.getAttribute('data-store');
      const dataAddress = store.getAttribute('data-address');
      const dataTel = store.getAttribute('data-tel');
      
      const allStoreKeywordsPresent = keywords.every(keyword => dataStore.includes(keyword));
      const allAddressKeywordsPresent = keywords.every(keyword => dataAddress.includes(keyword));
      const allTelKeywordsPresent = keywords.every(keyword => {
        const sanitizedTel = dataTel.replace(/-/g, '');
        const sanitizedKeyword = keyword.replace(/-/g, '');
        return sanitizedTel.includes(sanitizedKeyword);
      });
      
      if(!allStoreKeywordsPresent && !allAddressKeywordsPresent && !allTelKeywordsPresent) {
        store.style.display = 'none';
      }
    }

    // ランドセルをもとに絞り込み
    if(product) {
      const storeProducts = store.querySelectorAll('[data-product-title]');
      const dataProducts = Array.from(storeProducts).map(element => element.getAttribute('data-product-title'));
      if(!dataProducts.includes(product)) {
        store.style.display = 'none';
      }
    }

    if (store.style.display !== 'none') {
      resultStoreCount++;
    }
  });

  // 検索結果数を表示
  const searchResultArea = document.getElementById('searchResultNum');
  const searchResultText = document.getElementById('searchResultText');
  searchResultArea.innerText = resultStoreCount;
  if(resultStoreCount == 0) {
    searchResultText.innerText = "取り扱い店舗は見つかりませんでした。";
  }

  //直営店、認定ストア、取り扱い店舗 それぞれ該当数が0の場合、エリアを非表示
  const ShopsAreas = document.querySelectorAll('.sbn-p-section-pagesshops-managed');
  ShopsAreas.forEach(function(section) {
    const allStores = section.querySelectorAll('[data-prefecture]');
    let allHidden = true;
    allStores.forEach(function(store) {
      const computedStyle = window.getComputedStyle(store);
      if (computedStyle.display !== 'none') {
        allHidden = false;
      }
    });
    if (allHidden) {
      if(section.id == "handleShops") {
        section.querySelector('.sbn-result-wrapper').style.display = 'none';
      }else {
        section.style.display = 'none';
      }
    }
  });
});

